import React, { useState, useEffect } from "react";
import { Grid, Stack } from "@mui/material";
import InputField from "../../common/InputField";
import { Typography } from "@mui/material";
import "./CreateSessionForm.scss";
import Dropdown from "../../common/Dropdown";
import Info from "../../../Images/yellow_info_icon.svg";
import InputTags from "../../common/InputTags";
import moment from "moment-timezone";
import _ from "lodash";
import { components } from "react-select";
import ToolTip from "../../common/Tooltip";
import Textarea from "../../common/Textarea";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import Button from "../../common/Button";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API, APP_ROUTES } from "../../../globals/constants/index";
import { isEmpty, FORM_VALIDATION } from "../../../globals/constants";
import {
  InstructorList,
  StudioList,
  FeedbackList,
} from "../../../redux/features/CreatesessionDropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  sessionDetails,
  cloudType,
} from "../../../redux/features/CreateSessionReducer";
import Cookies from "universal-cookie";

function CreateSessionForm(props) {
  const dispatch = useDispatch();
  const [sessionTitle, setSessionTitle] = useState("");
  const [skills, setSkills] = useState([]);
  const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  const [timezoneSelectedId, setTimeZoneSelectedId] = useState("");
  const [selectedValue, setSelectedValue] = React.useState("training");
  const [selectedOption, setSelectedOption] = useState("studio");
  const [selectedTrainingOption, setSelectedTrainingOption] =
    useState("private");
  const [instructor, setInstructor] = useState([]);
  const [instructorSelectedId, setInstructorSelectedId] = useState("");
  const [studioList, setStudioList] = useState([
    {
      label: "abc",
      value: "1",
      id: "1",
    },
    {
      label: "efg",
      value: "2",
      id: "2",
    },
  ]);
  const [studio, setStudio] = useState("");
  const [sessionLink, setSessionLink] = useState("");
  const [sessionDescription, setSessionDescription] = useState("");
  const [checked, setChecked] = useState("private");
  const [feedbackSelectedId, setFeedbackSelectedId] = useState("");
  const [feedbackData, setFeedbackData] = useState([]);
  const [emailData, setEmailData] = useState([]);
  const [emailTemplateId, setEmailTemplateId] = useState("");
  const [errors, setErrors] = useState({
    sessionTitle: false,
    skills: false,
    sessionLink: false,
    feedback: false,
    description: false,
  });
  // const loginData = useSelector((state) => {
  //   return state.login?.loginResponse.data;
  // });
  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  const feedbackListing = useSelector((state) => {
    console.log("check state create sessison form", state);
    return state?.feedbackList;
  });
  useEffect(() => {
    getFeedbackList();
  }, [feedbackListing]);
  const createSessionData = useSelector((state) => {
    return state?.CreateSession?.sessionDetails;
  });
  const selectedSessionOption = useSelector((state) => {
    console.log("check thr type of cloudp]p]p", state?.CreateSession);
    return state?.CreateSession?.cloudType;
  });
  const EmailTemplateList = async () => {
    const response = await api_call(
      "get",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.EMAIL_LIST,
      {
        unique_id: loginData.studio_id,
      }
    );
    console.log("check responsebsdvgsh", response);
    if (response.status === 200) {
      let emailTempHolder = {};
      let data = response?.data?.data?.rows.map((item) => {
        let temp = {
          id: item.id,
          value: item.template_name,
          label: item.template_name,
        };
        return temp;
      });
      // Sort emailData to bring default email on top
      for (const i in data) {
        if (data[i]?.id === "6bc7286f-fad9-41ce-8eb5-9f34d1440152") {
          emailTempHolder = data[0];
          data[0] = data[i];
          data[i] = emailTempHolder;
        }
      }
      setEmailData([...data]);
      if (createSessionData) {
        let email_data = data
          ? data.filter(
              (item) => item.id === createSessionData?.email_template_id
            )
          : "";
        setEmailTemplateId(email_data[0]);
      }
    }
  };
  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    border: "1px solid #fff",
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#137cbd00" : "#137cbd00",
    "input:hover ~ &": {
      backgroundColor: "#137cbd00",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#137cbd00",
    "&:before": {
      display: "block",
      width: "12px",
      height: "12px",
      backgroundColor: "#fff",
      content: '""',
      borderRadius: "50px",
      margin: "3px",
    },
  });

  function BpRadio(props) {
    return (
      <Radio
        sx={{
          "&:hover": {
            bgcolor: "transparent",
          },
        }}
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    );
  }
  const handleTrainings = (event) => {
    setSelectedValue(event.target.value);
  };
  const isValid = () => {
    let error = false;
    console.log(
      "FORM_VALIDATION.SCRIPT.test(sessionTitle)",
      sessionTitle !== "",
      FORM_VALIDATION.SCRIPT.test(sessionTitle)
    );
    if (sessionDescription) {
      if (
        sessionTitle &&
        sessionTitle.trim().length !== 0 &&
        skills.length !== 0 &&
        sessionLink &&
        sessionLink.trim().length !== 0 &&
        feedbackSelectedId &&
        sessionDescription &&
        sessionDescription.trim().length !== 0 &&
        emailTemplateId &&
        FORM_VALIDATION.SCRIPT.test(sessionTitle) &&
        FORM_VALIDATION.SCRIPT.test(skills) &&
        FORM_VALIDATION.SCRIPT.test(sessionDescription) &&
        FORM_VALIDATION.URL.test(sessionLink) &&
        sessionDescription.trim().length !== 0 &&
        sessionTitle.trim().length !== 0
      ) {
        return (error = false);
      } else {
        return (error = true);
      }
    } else {
      if (
        sessionTitle &&
        sessionTitle.trim().length !== 0 &&
        skills.length !== 0 &&
        sessionLink &&
        sessionLink.trim().length !== 0 &&
        feedbackSelectedId &&
        emailTemplateId &&
        sessionDescription &&
        sessionDescription.trim().length !== 0 &&
        FORM_VALIDATION.SCRIPT.test(sessionTitle) &&
        FORM_VALIDATION.SCRIPT.test(skills) &&
        FORM_VALIDATION.SCRIPT.test(sessionDescription) &&
        FORM_VALIDATION.URL.test(sessionLink) &&
        sessionDescription.trim().length !== 0 &&
        sessionTitle.trim().length !== 0
      ) {
        return (error = false);
      } else {
        return (error = true);
      }
    }
    return error;
  };
  const onSubmit = () => {
    if (!isValid()) {
      if (selectedSessionOption) {
        dispatch(
          sessionDetails({
            title: sessionTitle,
            tags: skills ? JSON.stringify(skills) : "",
            host: sessionLink,
            feedback_template_id: feedbackSelectedId.id,
            description: sessionDescription,
            is_private: selectedTrainingOption === "private" ? true : false,
            email_template_id: emailTemplateId?.id,
          }),
          dispatch(
            cloudType({
              sessionType: selectedValue,
              gcpType: selectedSessionOption?.gcpType,
            })
          )
        );
      } else {
        dispatch(
          sessionDetails({
            title: sessionTitle,
            tags: skills ? JSON.stringify(skills) : "",
            host: sessionLink,
            feedback_template_id: feedbackSelectedId.id,
            description: sessionDescription,
            is_private: selectedTrainingOption === "private" ? true : false,
            email_template_id: emailTemplateId?.id,
          }),
          dispatch(
            cloudType({
              sessionType: selectedValue,
            })
          )
        );
      }

      props.handleNext(selectedValue);
    } else {
      console.log(
        "jjjjyyyyyyyy",
        !sessionTitle,
        FORM_VALIDATION.SCRIPT.test(sessionTitle)
      );
      setErrors({
        sessionTitle:
          !sessionTitle ||
          FORM_VALIDATION.SCRIPT.test(sessionTitle) === false ||
          sessionTitle.trim().length == 0
            ? true
            : false,
        skills:
          skills.length === 0 || FORM_VALIDATION.SCRIPT.test(skills) === false
            ? true
            : false,
        sessionLink:
          !sessionLink ||
          sessionLink.trim().length === 0 ||
          FORM_VALIDATION.URL.test(sessionLink) === false
            ? true
            : false,
        feedback: !feedbackSelectedId ? true : false,
        // description:
        //   sessionDescription === "" ||
        //   FORM_VALIDATION.SCRIPT.test(sessionDescription) === false ||
        //   sessionDescription.trim().length === 0
        //     ? true
        //     : false,
        description: !sessionDescription
          ? true
          : FORM_VALIDATION.SCRIPT.test(sessionDescription) === false ||
            sessionDescription.trim().length == 0
          ? true
          : false,
      });
    }
  };
  const getFeedbackList = async () => {
    if (feedbackListing?.loading === true) {
    } else {
      let feedbackTempHolder = {};
      let data = feedbackListing?.feedback?.data?.data?.rows;
      let data_feedback = data?.map((item) => {
        let temp = {
          id: item.id,
          value: item.feedback_form_id,
          label: `${item.feedback_form_name}(${item.feedback_form_id})`,
        };
        return temp;
      });
      for (const i in data_feedback) {
        if (data_feedback[i]?.id === "2b70a478-1848-4c32-81d5-aad2606cdc4e") {
          feedbackTempHolder = data_feedback[0];
          data_feedback[0] = data_feedback[i];
          data_feedback[i] = feedbackTempHolder;
        }
      }
      if (createSessionData) {
        let feedback_data = data_feedback
          ? data_feedback.filter(
              (item) => item.id === createSessionData?.feedback_template_id
            )
          : "";
        setFeedbackSelectedId(feedback_data[0]);
      }
      setFeedbackData(data_feedback.length > 0 ? [...data_feedback] : []);
    }
  };
  useEffect(() => {}, [feedbackData]);
  useEffect(() => {
    if (createSessionData) {
      let skills = createSessionData?.tags
        ? JSON.parse(createSessionData?.tags)
        : "";
      setSessionTitle(createSessionData?.title);
      setSkills(skills);
      setSessionDescription(createSessionData?.description);
      setSessionLink(createSessionData?.host);
      setSelectedTrainingOption(
        createSessionData?.is_private === true ? "private" : "public"
      );
    } else {
    }
  }, [createSessionData]);
  useEffect(() => {
    if (selectedSessionOption?.sessionType) {
      setSelectedValue(selectedSessionOption?.sessionType);
    }
  }, [selectedSessionOption?.sessionType]);
  useEffect(() => {
    let feedback_param = {
      unique_id:
        loginData.role_code === "STUDIO_ADMIN"
          ? loginData.studio_id
          : loginData.id,
    };
    dispatch(FeedbackList({ feedback_param }));
  }, []);
  useEffect(() => {}, [selectedValue]);
  useEffect(() => {
    EmailTemplateList();
  }, []);
  return (
    <>
      <Grid container rowSpacing={1} columnSpacing={2} className="set_height">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          {/* <FormControl>
            <FormLabel
              id="demo-radio-buttons-group-label"
              className="formLabel"
            >
              This session will be used for:
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={selectedValue}
              name="radio-buttons-group"
              onChange={handleTrainings}
              className="formGroup"
            >
              <FormControlLabel
                value="training"
                control={<BpRadio />}
                label="Training"
              />
              <FormControlLabel
                value="longtermsession"
                control={<BpRadio />}
                label="Longterm Session"
              />
            </RadioGroup>
          </FormControl> */}
          <div className="flexClass type_session_heading ">
            <Typography className="Session_type">
              This session will be used for:
            </Typography>
            <div className="flexClass sessionSelect ">
              <input
                type="radio"
                value="training"
                onChange={handleTrainings}
                checked={selectedValue === "training" ? true : false}
                disabled={props.action === "copy"}
              />
              {/* <ToolTip title={"AWS"} placement="top-start" arrow>
               
              </ToolTip> */}
              <label className="Session_type"> Training</label>
              {/* <input
                type="radio"
                value="longtermsession"
                onChange={handleTrainings}
                checked={selectedValue === "longtermsession" ? true : false}
                disabled={props.action === "copy"}
              />
              <label className="Session_type">Longterm Session</label> */}
              {/* <ToolTip title={"GCP"} placement="top-start" arrow>
               
              </ToolTip> */}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Session Title
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <InputField
                type="text"
                placeholder="Session title"
                value={sessionTitle}
                onChange={(e) => setSessionTitle(e.target.value)}
              />
              {errors.sessionTitle && (
                <small className="error small_f">
                  Please enter session title *
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Unique name for the session. Eg : 'Studio Example Training 10th July to 14th Sept 2023'"
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Skills
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <InputTags
                placeholder="Add skills hit enter (eg: Gaming) &amp;"
                tags={skills}
                // editable={this.state.actionOnpage === CONSTANTS.ACTION.EDIT}
                removeOnBackspace={true}
                onChange={(val) => {
                  setSkills(val);
                }}
              />
              {errors.skills && (
                <small className="error small_f">
                  Enter Valid Skills And Hit Enter*
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Provide skills that are covered in this training. You can add multiple skills. Skills are for self-reference only."
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Session Link
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <InputField
                type="text"
                placeholder="Add session link"
                value={sessionLink}
                onChange={(e) => setSessionLink(e.target.value)}
              />
              {errors.sessionLink && (
                <small className="error small_f">
                  Enter Valid Session Link *
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Please provide your meeting link(Google meet, Zoom etc) here"
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Feedback Menu
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <Dropdown
                placeholder="Select feedback"
                options={feedbackData}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) => setFeedbackSelectedId(selected)}
                allowSelectAll={true}
                value={feedbackSelectedId}
              />
              {errors.feedback && (
                <small className="error small_f">
                  Please Select feedback *
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Select a feedback form. An automated feedback form email is sent to the students when a training is over to gather feedback. You can also create a custom feedback form by clicking on the 'Feedback' section"
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Email Template
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <Dropdown
                placeholder="Select email template"
                options={emailData}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) => setEmailTemplateId(selected)}
                allowSelectAll={true}
                value={emailTemplateId}
              />
              {errors.feedback && (
                <small className="error small_f">
                  Please Select EmailTemplate*
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={"Select welcome email template"}
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Stack direction="row">
            <Stack direction="row">
              <label className="radiobtn">
                <input
                  type="radio"
                  value="private"
                  onChange={(e) => setSelectedTrainingOption(e.target.value)}
                  checked={selectedTrainingOption === "private" ? true : false}
                />
                <span className="checkmark"></span>
              </label>
              <Typography variant="h6" className="FieldHeading">
                Private
              </Typography>
            </Stack>
            <Stack direction="row">
              <label className="radiobtn">
                <input
                  type="radio"
                  name="radio"
                  value="public"
                  onChange={(e) => setSelectedTrainingOption(e.target.value)}
                  checked={selectedTrainingOption === "public" ? true : false}
                />
              </label>
              <Typography variant="h6" className="FieldHeading">
                Public
              </Typography>
            </Stack>
            <Stack direction="row">
              <div className="infostyle">
                <ToolTip
                  title={
                    "Currently it does not matter if you choose Private or Public. In the near future, Public sessions will be listed in the Students' page, while Private sessions will be visible only to the training centers and instructors."
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container spacing={1}>
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <Typography variant="h6" className="FieldHeading">
                Session Description
              </Typography>
            </Grid>
            <Grid item xs={9.5} sm={9.5} md={9.5} lg={9.5} xl={9.5}>
              <Textarea
                placeholder="Session Description"
                id="sessiondescription"
                type="text"
                value={sessionDescription}
                onChange={(e) => setSessionDescription(e.target.value)}
              />
              {errors.description && (
                <small className="error small_f">
                  Please provide session description *
                </small>
              )}
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.5} lg={0.5} xl={0.5}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Provide a description that details the topics covered during this training, prerequistes for the class, study materials and any other relevant information. Students will see this description when they are invited to this class."
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className="align_btm"></Grid>
      <Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mt: 1 }}>
          <Button
            value="Continue"
            role="primary"
            onClick={() => {
              onSubmit();
            }}
            className="paddingTop"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default CreateSessionForm;
